import { Component, OnInit, Inject } from '@angular/core';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-holiday-type-empty',
  templateUrl: './holiday-type-empty.component.html',
  styleUrls: ['./holiday-type-empty.component.css']
})
export class HolidayTypeEmptyComponent implements OnInit {
  form: FormGroup;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private calendarService: CalendarService,
    private dialogRef: MatDialogRef<HolidayTypeEmptyComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
  }
  createForm() {
    this.form = this.fb.group({
      Id: [this.data["id"]],
      Title: [
        this.data && this.data["Title"] ? this.data["Title"] : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100),
          Validators.minLength(1)
        ])
      ],
    })
  
  }
  submit(form) {
   
    this.errors = new Array();
    let command ={
      Id: form.Id,
      Title: form.Title,
      CompanyEncryptId: this.data.companyId
    }
    if (form.Id && form.Id > 0) {
      this.calendarService.holidayTypeEdit(command).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    } else {
      this.calendarService.holidayTypeAdd(command).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
